export default __webpack_public_path__ + "images/76f419c02fb9ff818d2f312c84013242.png";